import React from 'react';
import './App.scss';

import { calculateResistances, calculateCoverage } from "./helpers/resistance";

class App extends React.Component {
  constructor(props) {
    super(props);
    const baseURL = document.getElementById("base-url") ? document.getElementById("base-url").getAttribute("data-url") : "";
    this.state = {
      baseURL,
      navOpen: false,
      types: ["none", "none"],
    }
  }

  onToggleNav = () => {
    const { navOpen } = this.state;

    this.setState({
      navOpen: !navOpen,
    });
  }

  onSelectType = (slot, type) => {
    let { types } = this.state;

    types[slot] = type;
    this.setState({
      types
    });
  }

  render() {
    let types = [];
    let resistances = {}
    let strengths = [{},{}];
    if (this.state.types[0] !== "none") {
      types.push(this.state.types[0])
      if (this.state.types[1] !== "none" && this.state.types[0] !== this.state.types[1]) {
        types.push(this.state.types[1])
      }
      resistances = calculateResistances(types)
    } else if (this.state.types[1] !== "none") {
      types.push(this.state.types[1]);
      resistances = calculateResistances(types)
    }
    if (this.state.types[0] !== "none") {
      strengths[0] = calculateCoverage(this.state.types[0]);
    }
    if (this.state.types[1] !== "none") {
      strengths[1] = calculateCoverage(this.state.types[1]);
    }
    // let res2 = [];
    // let res4 = [];
    // let weak2 = [];
    // let weak4 = [];

    // for (const [type, resistance] of Object.entries(resistances)) {
    //   switch(resistance){
    //     case 0.25:
    //       res4.push(type)
    //       break;
    //     case 0.5:
    //       res2.push(type)
    //       break;
    //     case 2:
    //       weak2.push(type)
    //       break;
    //     case 4:
    //       weak4.push(type)
    //       break;
    //     default:
    //       break;
    //   }
    // }

    return (
      <div className="App">
        <div className="panel-left">
          <div className="typing-select">
            <div className="current-selected">
                {this.state.types[0] !== "none" ? (
                  <div className="icon">
                    <span className={`type ${this.state.types[0].toLowerCase()}`}></span>
                  </div>
                ): (
                  <div className="icon select-none">
                    <i className="lni-minus"></i>
                  </div>
                )}
              <div className="name">{this.state.types[0].toLowerCase()}</div>
            </div>
            <div className="available-types">
              <span className={`none${this.state.types[0] === "none" ? " active" : ""}`} onClick={() => this.onSelectType(0, "none")}><i className="lni-minus"></i></span>
              <span className={`type crystal${this.state.types[0] === "crystal" ? " active": ""}`} onClick={() => this.onSelectType(0, "crystal")}></span>
              <span className={`type digital${this.state.types[0] === "digital" ? " active": ""}`} onClick={() => this.onSelectType(0, "digital")}></span>
              <span className={`type earth${this.state.types[0] === "earth" ? " active": ""}`} onClick={() => this.onSelectType(0, "earth")}></span>
              <span className={`type electric${this.state.types[0] === "electric" ? " active": ""}`} onClick={() => this.onSelectType(0, "electric")}></span>
              <span className={`type fire${this.state.types[0] === "fire" ? " active": ""}`} onClick={() => this.onSelectType(0, "fire")}></span>
              <span className={`type melee${this.state.types[0] === "melee" ? " active": ""}`} onClick={() => this.onSelectType(0, "melee")}></span>
              <span className={`type mental${this.state.types[0] === "mental" ? " active": ""}`} onClick={() => this.onSelectType(0, "mental")}></span>
              <span className={`type nature${this.state.types[0] === "nature" ? " active": ""}`} onClick={() => this.onSelectType(0, "nature")}></span>
              <span className={`type neutral${this.state.types[0] === "neutral" ? " active": ""}`} onClick={() => this.onSelectType(0, "neutral")}></span>
              <span className={`type toxic${this.state.types[0] === "toxic" ? " active": ""}`} onClick={() => this.onSelectType(0, "toxic")}></span>
              <span className={`type water${this.state.types[0] === "water" ? " active": ""}`} onClick={() => this.onSelectType(0, "water")}></span>
              <span className={`type wind${this.state.types[0] === "wind" ? " active": ""}`} onClick={() => this.onSelectType(0, "wind")}></span>
            </div>
          </div>
          <div className="typing-select">
            <div className="current-selected">
                {this.state.types[1] !== "none" ? (
                  <div className="icon">
                    <span className={`type ${this.state.types[1].toLowerCase()}`}></span>
                  </div>
                ): (
                  <div className="icon select-none">
                    <i className="lni-minus"></i>
                  </div>
                )}
              <div className="name">{this.state.types[1].toLowerCase()}</div>
            </div>
            <div className="available-types">
              <span className={`none${this.state.types[1] === "none" ? " active" : ""}`} onClick={() => this.onSelectType(1, "none")}><i className="lni-minus"></i></span>
              <span className={`type crystal${this.state.types[1] === "crystal" ? " active": ""}`} onClick={() => this.onSelectType(1, "crystal")}></span>
              <span className={`type digital${this.state.types[1] === "digital" ? " active": ""}`} onClick={() => this.onSelectType(1, "digital")}></span>
              <span className={`type earth${this.state.types[1] === "earth" ? " active": ""}`} onClick={() => this.onSelectType(1, "earth")}></span>
              <span className={`type electric${this.state.types[1] === "electric" ? " active": ""}`} onClick={() => this.onSelectType(1, "electric")}></span>
              <span className={`type fire${this.state.types[1] === "fire" ? " active": ""}`} onClick={() => this.onSelectType(1, "fire")}></span>
              <span className={`type melee${this.state.types[1] === "melee" ? " active": ""}`} onClick={() => this.onSelectType(1, "melee")}></span>
              <span className={`type mental${this.state.types[1] === "mental" ? " active": ""}`} onClick={() => this.onSelectType(1, "mental")}></span>
              <span className={`type nature${this.state.types[1] === "nature" ? " active": ""}`} onClick={() => this.onSelectType(1, "nature")}></span>
              <span className={`type neutral${this.state.types[1] === "neutral" ? " active": ""}`} onClick={() => this.onSelectType(1, "neutral")}></span>
              <span className={`type toxic${this.state.types[1] === "toxic" ? " active": ""}`} onClick={() => this.onSelectType(1, "toxic")}></span>
              <span className={`type water${this.state.types[1] === "water" ? " active": ""}`} onClick={() => this.onSelectType(1, "water")}></span>
              <span className={`type wind${this.state.types[1] === "wind" ? " active": ""}`} onClick={() => this.onSelectType(1, "wind")}></span>
            </div>
          </div>
        </div>
        {this.state.types[0] !== "none" || this.state.types[1] !== "none" ? (
          <div className="panel-right">
            <div className="resistances">
              <h2>Resistances</h2>
              <div className="resistance-table">
                <div className="table-row table-header">
                  <div className="table-column"><span className="type crystal"></span></div>
                  <div className="table-column"><span className="type digital"></span></div>
                  <div className="table-column"><span className="type earth"></span></div>
                  <div className="table-column"><span className="type electric"></span></div>
                  <div className="table-column"><span className="type fire"></span></div>
                  <div className="table-column"><span className="type melee"></span></div>
                  <div className="table-column"><span className="type mental"></span></div>
                  <div className="table-column"><span className="type nature"></span></div>
                  <div className="table-column"><span className="type neutral"></span></div>
                  <div className="table-column"><span className="type toxic"></span></div>
                  <div className="table-column"><span className="type water"></span></div>
                  <div className="table-column"><span className="type wind"></span></div>
                </div>
                <div className="table-row">
                  <div className={`table-column ${resistances["crystal"] === 4 ? "x4" : resistances["crystal"] === 2 ? "x2" : resistances["crystal"] === 0.5 ? "x05" : resistances["crystal"] === 0.25 ? "x025" : ""}`}>{resistances["crystal"]}x</div>
                  <div className={`table-column ${resistances["digital"] === 4 ? "x4" : resistances["digital"] === 2 ? "x2" : resistances["digital"] === 0.5 ? "x05" : resistances["digital"] === 0.25 ? "x025" : ""}`}>{resistances["digital"]}x</div>
                  <div className={`table-column ${resistances["earth"] === 4 ? "x4" : resistances["earth"] === 2 ? "x2" : resistances["earth"] === 0.5 ? "x05" : resistances["earth"] === 0.25 ? "x025" : ""}`}>{resistances["earth"]}x</div>
                  <div className={`table-column ${resistances["electric"] === 4 ? "x4" : resistances["electric"] === 2 ? "x2" : resistances["electric"] === 0.5 ? "x05" : resistances["electric"] === 0.25 ? "x025" : ""}`}>{resistances["electric"]}x</div>
                  <div className={`table-column ${resistances["fire"] === 4 ? "x4" : resistances["fire"] === 2 ? "x2" : resistances["fire"] === 0.5 ? "x05" : resistances["fire"] === 0.25 ? "x025" : ""}`}>{resistances["fire"]}x</div>
                  <div className={`table-column ${resistances["melee"] === 4 ? "x4" : resistances["melee"] === 2 ? "x2" : resistances["melee"] === 0.5 ? "x05" : resistances["melee"] === 0.25 ? "x025" : ""}`}>{resistances["melee"]}x</div>
                  <div className={`table-column ${resistances["mental"] === 4 ? "x4" : resistances["mental"] === 2 ? "x2" : resistances["mental"] === 0.5 ? "x05" : resistances["mental"] === 0.25 ? "x025" : ""}`}>{resistances["mental"]}x</div>
                  <div className={`table-column ${resistances["nature"] === 4 ? "x4" : resistances["nature"] === 2 ? "x2" : resistances["nature"] === 0.5 ? "x05" : resistances["nature"] === 0.25 ? "x025" : ""}`}>{resistances["nature"]}x</div>
                  <div className={`table-column ${resistances["neutral"] === 4 ? "x4" : resistances["neutral"] === 2 ? "x2" : resistances["neutral"] === 0.5 ? "x05" : resistances["neutral"] === 0.25 ? "x025" : ""}`}>{resistances["neutral"]}x</div>
                  <div className={`table-column ${resistances["toxic"] === 4 ? "x4" : resistances["toxic"] === 2 ? "x2" : resistances["toxic"] === 0.5 ? "x05" : resistances["toxic"] === 0.25 ? "x025" : ""}`}>{resistances["toxic"]}x</div>
                  <div className={`table-column ${resistances["water"] === 4 ? "x4" : resistances["water"] === 2 ? "x2" : resistances["water"] === 0.5 ? "x05" : resistances["water"] === 0.25 ? "x025" : ""}`}>{resistances["water"]}x</div>
                  <div className={`table-column ${resistances["wind"] === 4 ? "x4" : resistances["wind"] === 2 ? "x2" : resistances["wind"] === 0.5 ? "x05" : resistances["wind"] === 0.25 ? "x025" : ""}`}>{resistances["wind"]}x</div>
                </div>
              </div>
            </div>
            {/* TODO */}
            <div className="resistances">
              <h2>Coverage</h2>
              {this.state.types[0] !== "none" ? (
                <React.Fragment>
                  <h3><span className={`type ${this.state.types[0]}`}></span>{this.state.types[0]}</h3>
                  <div className="resistance-table">
                    <div className="table-row table-header">
                      <div className="table-column"><span className="type crystal"></span></div>
                      <div className="table-column"><span className="type digital"></span></div>
                      <div className="table-column"><span className="type earth"></span></div>
                      <div className="table-column"><span className="type electric"></span></div>
                      <div className="table-column"><span className="type fire"></span></div>
                      <div className="table-column"><span className="type melee"></span></div>
                      <div className="table-column"><span className="type mental"></span></div>
                      <div className="table-column"><span className="type nature"></span></div>
                      <div className="table-column"><span className="type neutral"></span></div>
                      <div className="table-column"><span className="type toxic"></span></div>
                      <div className="table-column"><span className="type water"></span></div>
                      <div className="table-column"><span className="type wind"></span></div>
                    </div>
                    <div className="table-row">
                      <div className={`table-column ${strengths[0]["crystal"] === 4 ? "x4" : strengths[0]["crystal"] === 2 ? "x2" : strengths[0]["crystal"] === 0.5 ? "x05" : strengths[0]["crystal"] === 0.25 ? "x025" : ""}`}>{strengths[0]["crystal"]}x</div>
                      <div className={`table-column ${strengths[0]["digital"] === 4 ? "x4" : strengths[0]["digital"] === 2 ? "x2" : strengths[0]["digital"] === 0.5 ? "x05" : strengths[0]["digital"] === 0.25 ? "x025" : ""}`}>{strengths[0]["digital"]}x</div>
                      <div className={`table-column ${strengths[0]["earth"] === 4 ? "x4" : strengths[0]["earth"] === 2 ? "x2" : strengths[0]["earth"] === 0.5 ? "x05" : strengths[0]["earth"] === 0.25 ? "x025" : ""}`}>{strengths[0]["earth"]}x</div>
                      <div className={`table-column ${strengths[0]["electric"] === 4 ? "x4" : strengths[0]["electric"] === 2 ? "x2" : strengths[0]["electric"] === 0.5 ? "x05" : strengths[0]["electric"] === 0.25 ? "x025" : ""}`}>{strengths[0]["electric"]}x</div>
                      <div className={`table-column ${strengths[0]["fire"] === 4 ? "x4" : strengths[0]["fire"] === 2 ? "x2" : strengths[0]["fire"] === 0.5 ? "x05" : strengths[0]["fire"] === 0.25 ? "x025" : ""}`}>{strengths[0]["fire"]}x</div>
                      <div className={`table-column ${strengths[0]["melee"] === 4 ? "x4" : strengths[0]["melee"] === 2 ? "x2" : strengths[0]["melee"] === 0.5 ? "x05" : strengths[0]["melee"] === 0.25 ? "x025" : ""}`}>{strengths[0]["melee"]}x</div>
                      <div className={`table-column ${strengths[0]["mental"] === 4 ? "x4" : strengths[0]["mental"] === 2 ? "x2" : strengths[0]["mental"] === 0.5 ? "x05" : strengths[0]["mental"] === 0.25 ? "x025" : ""}`}>{strengths[0]["mental"]}x</div>
                      <div className={`table-column ${strengths[0]["nature"] === 4 ? "x4" : strengths[0]["nature"] === 2 ? "x2" : strengths[0]["nature"] === 0.5 ? "x05" : strengths[0]["nature"] === 0.25 ? "x025" : ""}`}>{strengths[0]["nature"]}x</div>
                      <div className={`table-column ${strengths[0]["neutral"] === 4 ? "x4" : strengths[0]["neutral"] === 2 ? "x2" : strengths[0]["neutral"] === 0.5 ? "x05" : strengths[0]["neutral"] === 0.25 ? "x025" : ""}`}>{strengths[0]["neutral"]}x</div>
                      <div className={`table-column ${strengths[0]["toxic"] === 4 ? "x4" : strengths[0]["toxic"] === 2 ? "x2" : strengths[0]["toxic"] === 0.5 ? "x05" : strengths[0]["toxic"] === 0.25 ? "x025" : ""}`}>{strengths[0]["toxic"]}x</div>
                      <div className={`table-column ${strengths[0]["water"] === 4 ? "x4" : strengths[0]["water"] === 2 ? "x2" : strengths[0]["water"] === 0.5 ? "x05" : strengths[0]["water"] === 0.25 ? "x025" : ""}`}>{strengths[0]["water"]}x</div>
                      <div className={`table-column ${strengths[0]["wind"] === 4 ? "x4" : strengths[0]["wind"] === 2 ? "x2" : strengths[0]["wind"] === 0.5 ? "x05" : strengths[0]["wind"] === 0.25 ? "x025" : ""}`}>{strengths[0]["wind"]}x</div>
                    </div>
                  </div>
                </React.Fragment>
              ) : null}
              {this.state.types[1] !== "none" ? (
                <React.Fragment>
                  <h3><span className={`type ${this.state.types[1]}`}></span>{this.state.types[1]}</h3>
                  <div className="resistance-table">
                    <div className="table-row table-header">
                      <div className="table-column"><span className="type crystal"></span></div>
                      <div className="table-column"><span className="type digital"></span></div>
                      <div className="table-column"><span className="type earth"></span></div>
                      <div className="table-column"><span className="type electric"></span></div>
                      <div className="table-column"><span className="type fire"></span></div>
                      <div className="table-column"><span className="type melee"></span></div>
                      <div className="table-column"><span className="type mental"></span></div>
                      <div className="table-column"><span className="type nature"></span></div>
                      <div className="table-column"><span className="type neutral"></span></div>
                      <div className="table-column"><span className="type toxic"></span></div>
                      <div className="table-column"><span className="type water"></span></div>
                      <div className="table-column"><span className="type wind"></span></div>
                    </div>
                    <div className="table-row">
                      <div className={`table-column ${strengths[1]["crystal"] === 4 ? "x4" : strengths[1]["crystal"] === 2 ? "x2" : strengths[1]["crystal"] === 0.5 ? "x05" : strengths[1]["crystal"] === 0.25 ? "x025" : ""}`}>{strengths[1]["crystal"]}x</div>
                      <div className={`table-column ${strengths[1]["digital"] === 4 ? "x4" : strengths[1]["digital"] === 2 ? "x2" : strengths[1]["digital"] === 0.5 ? "x05" : strengths[1]["digital"] === 0.25 ? "x025" : ""}`}>{strengths[1]["digital"]}x</div>
                      <div className={`table-column ${strengths[1]["earth"] === 4 ? "x4" : strengths[1]["earth"] === 2 ? "x2" : strengths[1]["earth"] === 0.5 ? "x05" : strengths[1]["earth"] === 0.25 ? "x025" : ""}`}>{strengths[1]["earth"]}x</div>
                      <div className={`table-column ${strengths[1]["electric"] === 4 ? "x4" : strengths[1]["electric"] === 2 ? "x2" : strengths[1]["electric"] === 0.5 ? "x05" : strengths[1]["electric"] === 0.25 ? "x025" : ""}`}>{strengths[1]["electric"]}x</div>
                      <div className={`table-column ${strengths[1]["fire"] === 4 ? "x4" : strengths[1]["fire"] === 2 ? "x2" : strengths[1]["fire"] === 0.5 ? "x05" : strengths[1]["fire"] === 0.25 ? "x025" : ""}`}>{strengths[1]["fire"]}x</div>
                      <div className={`table-column ${strengths[1]["melee"] === 4 ? "x4" : strengths[1]["melee"] === 2 ? "x2" : strengths[1]["melee"] === 0.5 ? "x05" : strengths[1]["melee"] === 0.25 ? "x025" : ""}`}>{strengths[1]["melee"]}x</div>
                      <div className={`table-column ${strengths[1]["mental"] === 4 ? "x4" : strengths[1]["mental"] === 2 ? "x2" : strengths[1]["mental"] === 0.5 ? "x05" : strengths[1]["mental"] === 0.25 ? "x025" : ""}`}>{strengths[1]["mental"]}x</div>
                      <div className={`table-column ${strengths[1]["nature"] === 4 ? "x4" : strengths[1]["nature"] === 2 ? "x2" : strengths[1]["nature"] === 0.5 ? "x05" : strengths[1]["nature"] === 0.25 ? "x025" : ""}`}>{strengths[1]["nature"]}x</div>
                      <div className={`table-column ${strengths[1]["neutral"] === 4 ? "x4" : strengths[1]["neutral"] === 2 ? "x2" : strengths[1]["neutral"] === 0.5 ? "x05" : strengths[1]["neutral"] === 0.25 ? "x025" : ""}`}>{strengths[1]["neutral"]}x</div>
                      <div className={`table-column ${strengths[1]["toxic"] === 4 ? "x4" : strengths[1]["toxic"] === 2 ? "x2" : strengths[1]["toxic"] === 0.5 ? "x05" : strengths[1]["toxic"] === 0.25 ? "x025" : ""}`}>{strengths[1]["toxic"]}x</div>
                      <div className={`table-column ${strengths[1]["water"] === 4 ? "x4" : strengths[1]["water"] === 2 ? "x2" : strengths[1]["water"] === 0.5 ? "x05" : strengths[1]["water"] === 0.25 ? "x025" : ""}`}>{strengths[1]["water"]}x</div>
                      <div className={`table-column ${strengths[1]["wind"] === 4 ? "x4" : strengths[1]["wind"] === 2 ? "x2" : strengths[1]["wind"] === 0.5 ? "x05" : strengths[1]["wind"] === 0.25 ? "x025" : ""}`}>{strengths[1]["wind"]}x</div>
                    </div>
                  </div>
                </React.Fragment>
              ) : null}
            </div>
          </div>
        ) : (
          <div className="panel-right">
            <div className="typings">
              <div className="typing"  onClick={() => this.onSelectType(0, "crystal")}>
                <div className="label">
                  <div className="icon">
                    <span className="type crystal"></span>
                  </div>
                  <span className="name">Crystal</span>
                </div>
                <div className="row header">
                  <div className="attack-defend"></div>
                  <div className="effective">Strong</div>
                  <div className="not-effective">Weak</div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-construction-hammer"></i>ATK</div>
                  <div className="effective">
                    <span className="type electric"></span>
                    <span className="type mental"></span>
                  </div>
                  <div className="not-effective">
                    <span className="type earth"></span>
                    <span className="type fire"></span>
                  </div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-shield"></i>DEF</div>
                  <div className="effective">
                    <span className="type electric"></span>
                    <span className="type mental"></span>
                    <span className="type toxic"></span>
                  </div>
                  <div className="not-effective">
                    <span className="type earth"></span>
                    <span className="type fire"></span>
                    <span className="type melee"></span>
                  </div>
                </div>
              </div>
              <div className="typing" onClick={() => this.onSelectType(0, "digital")}>
                <div className="label">
                  <div className="icon">
                    <span className="type digital"></span>
                  </div>
                  <span className="name">Digital</span>
                </div>
                <div className="row header">
                  <div className="attack-defend"></div>
                  <div className="effective">Strong</div>
                  <div className="not-effective">Weak</div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-construction-hammer"></i></div>
                  <div className="effective">
                    <span className="type digital"></span>
                    <span className="type melee"></span>
                    <span className="type mental"></span>
                  </div>
                  <div className="not-effective">
                  </div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-shield"></i></div>
                  <div className="effective">
                    <span className="type toxic"></span>
                  </div>
                  <div className="not-effective">
                    <span className="type digital"></span>
                    <span className="type electric"></span>
                    <span className="type water"></span>
                  </div>
                </div>
              </div>
              <div className="typing" onClick={() => this.onSelectType(0, "earth")}>
                <div className="label">
                  <div className="icon">
                    <span className="type earth"></span>
                  </div>
                  <span className="name">Earth</span>
                </div>
                <div className="row header">
                  <div className="attack-defend"></div>
                  <div className="effective">Strong</div>
                  <div className="not-effective">Weak</div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-construction-hammer"></i></div>
                  <div className="effective">
                    <span className="type crystal"></span>
                    <span className="type electric"></span>
                    <span className="type fire"></span>
                  </div>
                  <div className="not-effective">
                    <span className="type nature"></span>
                    <span className="type water"></span>
                    <span className="type wind"></span>
                  </div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-shield"></i></div>
                  <div className="effective">
                    <span className="type crystal"></span>
                    <span className="type electric"></span>
                    <span className="type fire"></span>
                    <span className="type toxic"></span>
                  </div>
                  <div className="not-effective">
                    <span className="type melee"></span>
                    <span className="type nature"></span>
                    <span className="type water"></span>
                  </div>
                </div>
              </div>
              <div className="typing"  onClick={() => this.onSelectType(0, "electric")}>
                <div className="label">
                  <div className="icon">
                    <span className="type electric"></span>
                  </div>
                  <span className="name">Electric</span>
                </div>
                <div className="row header">
                  <div className="attack-defend"></div>
                  <div className="effective">Strong</div>
                  <div className="not-effective">Weak</div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-construction-hammer"></i></div>
                  <div className="effective">
                    <span className="type digital"></span>
                    <span className="type mental"></span>
                    <span className="type water"></span>
                    <span className="type wind"></span>
                  </div>
                  <div className="not-effective">
                    <span className="type crystal"></span>
                    <span className="type earth"></span>
                    <span className="type electric"></span>
                    <span className="type nature"></span>
                  </div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-shield"></i></div>
                  <div className="effective">
                    <span className="type electric"></span>
                    <span className="type wind"></span>
                  </div>
                  <div className="not-effective">
                    <span className="type crystal"></span>
                    <span className="type earth"></span>
                  </div>
                </div>
              </div>
              <div className="typing" onClick={() => this.onSelectType(0, "fire")}>
                <div className="label">
                  <div className="icon">
                    <span className="type fire"></span>
                  </div>
                  <span className="name">Fire</span>
                </div>
                <div className="row header">
                  <div className="attack-defend"></div>
                  <div className="effective">Strong</div>
                  <div className="not-effective">Weak</div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-construction-hammer"></i></div>
                  <div className="effective">
                    <span className="type crystal"></span>
                    <span className="type nature"></span>
                  </div>
                  <div className="not-effective">
                    <span className="type earth"></span>
                    <span className="type fire"></span>
                    <span className="type water"></span>
                  </div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-shield"></i></div>
                  <div className="effective">
                    <span className="type crystal"></span>
                    <span className="type fire"></span>
                    <span className="type nature"></span>
                  </div>
                  <div className="not-effective">
                    <span className="type earth"></span>
                    <span className="type water"></span>
                  </div>
                </div>
              </div>
              <div className="typing" onClick={() => this.onSelectType(0, "melee")}>
                <div className="label">
                  <div className="icon">
                    <span className="type melee"></span>
                  </div>
                  <span className="name">Melee</span>
                </div>
                <div className="row header">
                  <div className="attack-defend"></div>
                  <div className="effective">Strong</div>
                  <div className="not-effective">Weak</div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-construction-hammer"></i></div>
                  <div className="effective">
                    <span className="type crystal"></span>
                    <span className="type earth"></span>
                  </div>
                  <div className="not-effective">
                    <span className="type melee"></span>
                    <span className="type mental"></span>
                  </div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-shield"></i></div>
                  <div className="effective">
                    <span className="type melee"></span>
                  </div>
                  <div className="not-effective">
                    <span className="type digital"></span>
                    <span className="type mental"></span>
                  </div>
                </div>
              </div>
              <div className="typing" onClick={() => this.onSelectType(0, "mental")}>
                <div className="label">
                  <div className="icon">
                    <span className="type mental"></span>
                  </div>
                  <span className="name">Mental</span>
                </div>
                <div className="row header">
                  <div className="attack-defend"></div>
                  <div className="effective">Strong</div>
                  <div className="not-effective">Weak</div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-construction-hammer"></i></div>
                  <div className="effective">
                    <span className="type melee"></span>
                    <span className="type neutral"></span>
                  </div>
                  <div className="not-effective">
                    <span className="type crystal"></span>
                  </div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-shield"></i></div>
                  <div className="effective">
                    <span className="type melee"></span>
                    <span className="type neutral"></span>
                  </div>
                  <div className="not-effective">
                    <span className="type crystal"></span>
                    <span className="type digital"></span>
                    <span className="type electric"></span>
                  </div>
                </div>
              </div>
              <div className="typing" onClick={() => this.onSelectType(0, "nature")}>
                <div className="label">
                  <div className="icon">
                    <span className="type nature"></span>
                  </div>
                  <span className="name">Nature</span>
                </div>
                <div className="row header">
                  <div className="attack-defend"></div>
                  <div className="effective">Strong</div>
                  <div className="not-effective">Weak</div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-construction-hammer"></i></div>
                  <div className="effective">
                    <span className="type earth"></span>
                    <span className="type water"></span>
                  </div>
                  <div className="not-effective">
                    <span className="type fire"></span>
                    <span className="type nature"></span>
                    <span className="type toxic"></span>
                  </div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-shield"></i></div>
                  <div className="effective">
                    <span className="type earth"></span>
                    <span className="type electric"></span>
                    <span className="type nature"></span>
                    <span className="type water"></span>
                  </div>
                  <div className="not-effective">
                    <span className="type fire"></span>
                    <span className="type toxic"></span>
                  </div>
                </div>
              </div>
              <div className="typing" onClick={() => this.onSelectType(0, "neutral")}>
                <div className="label">
                  <div className="icon">
                    <span className="type neutral"></span>
                  </div>
                  <span className="name">Neutral</span>
                </div>
                <div className="row header">
                  <div className="attack-defend"></div>
                  <div className="effective">Strong</div>
                  <div className="not-effective">Weak</div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-construction-hammer"></i></div>
                  <div className="effective">
                  </div>
                  <div className="not-effective">
                    <span className="type mental"></span>
                  </div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-shield"></i></div>
                  <div className="effective">
                  </div>
                  <div className="not-effective">
                    <span className="type mental"></span>
                  </div>
                </div>
              </div>
              <div className="typing" onClick={() => this.onSelectType(0, "toxic")}>
                <div className="label">
                  <div className="icon">
                    <span className="type toxic"></span>
                  </div>
                  <span className="name">Toxic</span>
                </div>
                <div className="row header">
                  <div className="attack-defend"></div>
                  <div className="effective">Strong</div>
                  <div className="not-effective">Weak</div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-construction-hammer"></i></div>
                  <div className="effective">
                    <span className="type nature"></span>
                    <span className="type water"></span>
                  </div>
                  <div className="not-effective">
                    <span className="type crystal"></span>
                    <span className="type digital"></span>
                    <span className="type earth"></span>
                    <span className="type toxic"></span>
                  </div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-shield"></i></div>
                  <div className="effective">
                    <span className="type nature"></span>
                    <span className="type toxic"></span>
                    <span className="type water"></span>
                  </div>
                  <div className="not-effective">
                    <span className="type wind"></span>
                  </div>
                </div>
              </div>
              <div className="typing" onClick={() => this.onSelectType(0, "water")}>
                <div className="label">
                  <div className="icon">
                    <span className="type water"></span>
                  </div>
                  <span className="name">Water</span>
                </div>
                <div className="row header">
                  <div className="attack-defend"></div>
                  <div className="effective">Strong</div>
                  <div className="not-effective">Weak</div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-construction-hammer"></i></div>
                  <div className="effective">
                    <span className="type digital"></span>
                    <span className="type earth"></span>
                    <span className="type fire"></span>
                  </div>
                  <div className="not-effective">
                    <span className="type nature"></span>
                    <span className="type toxic"></span>
                    <span className="type water"></span>
                  </div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-shield"></i></div>
                  <div className="effective">
                    <span className="type earth"></span>
                    <span className="type fire"></span>
                    <span className="type water"></span>
                  </div>
                  <div className="not-effective">
                    <span className="type electric"></span>
                    <span className="type nature"></span>
                    <span className="type toxic"></span>
                  </div>
                </div>
              </div>
              <div className="typing" onClick={() => this.onSelectType(0, "wind")}>
                <div className="label">
                  <div className="icon">
                    <span className="type wind"></span>
                  </div>
                  <span className="name">Wind</span>
                </div>
                <div className="row header">
                  <div className="attack-defend"></div>
                  <div className="effective">Strong</div>
                  <div className="not-effective">Weak</div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-construction-hammer"></i></div>
                  <div className="effective">
                    <span className="type toxic"></span>
                  </div>
                  <div className="not-effective">
                    <span className="type electric"></span>
                    <span className="type wind"></span>
                  </div>
                </div>
                <div className="row content">
                  <div className="attack-defend"><i className="lni-shield"></i></div>
                  <div className="effective">
                    <span className="type earth"></span>
                    <span className="type wind"></span>
                  </div>
                  <div className="not-effective">
                    <span className="type electric"></span>
                  </div>
                </div>
              </div>
              {/* END */}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default App;
